var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [(_vm.isLoading) ? _c('div', {
    staticClass: "row",
    staticStyle: {
      "height": "100px"
    }
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', [(!_vm.checkAllLoadded && !_vm.isLoading && _vm.showButtonRefresh) ? _c('div', {
    staticClass: "card-actions",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('button', {
    staticClass: "btn btn-info px-4",
    attrs: {
      "type": "button",
      "disabled": _vm.isLoading
    },
    on: {
      "click": _vm.refreshLog
    }
  }, [_vm._v("Refresh")])]) : _vm._e(), _vm._v(" "), (!_vm.checkAllLoadded && !_vm.isLoading && _vm.showButtonRefresh) ? _c('div', {
    staticClass: "card-actions",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('span', {
    staticClass: "text-danger",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Click to get Live Dashboard Details")])]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.checkAllLoadded) ? _c('b-tabs', [_c('b-tab', {
    attrs: {
      "title": "Today's History",
      "active": ""
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3 col-lg-3"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-body p-3 d-flex align-items-center"
  }, [_c('i', {
    staticClass: "fa fa-shopping-bag highlight-icon bg-primary p-3 font-2xl mr-3"
  }), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "card-text text-dark "
  }, [_vm._v("Good's Items received per hour")]), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.calculateTodatMonthHrs(_vm.grcData.today.received, 'today')))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-lg-3"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-body p-3 d-flex align-items-center"
  }, [_c('i', {
    staticClass: "fa fa-arrow-down highlight-icon bg-success p-3 font-2xl mr-3"
  }), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "card-text text-dark "
  }, [_vm._v("Items putaway per hour")]), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.calculateTodatMonthHrs(_vm.putAwayData.today.itemputaway, 'today')))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 col-sm-6 col-md-3 col-lg-3"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-body p-3 d-flex align-items-center"
  }, [_c('i', {
    staticClass: "fa fa-arrow-right highlight-icon bg-warning p-3 font-2xl mr-3"
  }), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "card-text text-dark "
  }, [_vm._v("Items picked per hour\n                  ")]), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.calculateTodatMonthHrs(_vm.pickingData.today.totalpicked, 'today')))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 col-sm-6 col-md-3 col-lg-3"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-body p-3 d-flex align-items-center"
  }, [_c('i', {
    staticClass: "fa fa-cube highlight-icon bg-danger p-3 font-2xl mr-3"
  }), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "card-text text-dark "
  }, [_vm._v("Items packed per hour\n                  ")]), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.calculateTodatMonthHrs(_vm.packingData.today.totalpacked, 'today')))])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3 col-lg-3"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-body p-3 d-flex align-items-center"
  }, [_c('i', {
    staticClass: "fa fa-angle-double-up highlight-icon bg-success p-3 font-2xl mr-3"
  }), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "card-text text-dark "
  }, [_vm._v("Items shipped per hour")]), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.calculateTodatMonthHrs(_vm.shippingData.today.totalshipped, 'today')))])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12"
  }, [_c('div', {
    staticClass: " col-md-3 main_container",
    staticStyle: {
      "background-color": "#f38439"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 box_header"
  }, [_c('h6', {
    staticClass: "box_head txtc"
  }, [_vm._v("Dock Receipt")])])]), _vm._v(" "), _c('div', {
    staticClass: "row sub_cont"
  }, [_c('div', {
    staticClass: "col-xs-6 col-sm-6 col-md-6 col-lg-6 divider"
  }, [_c('div', {
    staticClass: "text-value txtc"
  }, [_vm._v(_vm._s(_vm.dockReceiptData.today.totaldr))]), _vm._v(" "), _c('div', {
    staticClass: "text_head txtc"
  }, [_vm._v("Total Dock Receipt")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 col-sm-6 col-md-6 col-lg-6"
  }, [_c('div', {
    staticClass: "text-value txtc"
  }, [_vm._v(_vm._s(_vm.dockReceiptData.today.itemsvalue))]), _vm._v(" "), _c('div', {
    staticClass: "text_head txtc"
  }, [_vm._v("Value of Dock Receipt")])])])]), _vm._v(" "), _c('div', {
    staticClass: " col-md-3 main_container",
    staticStyle: {
      "background-color": "#f76d6c"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 box_header"
  }, [_c('h6', {
    staticClass: "box_head txtc"
  }, [_vm._v("GRC")])])]), _vm._v(" "), _c('div', {
    staticClass: "row sub_cont"
  }, [_c('div', {
    staticClass: "col-xs-6 col-sm-6 col-md-6 col-lg-6 divider"
  }, [_c('div', {
    staticClass: "text-value txtc"
  }, [_vm._v(_vm._s(_vm.grcData.today.received))]), _vm._v(" "), _c('div', {
    staticClass: "text_head txtc"
  }, [_vm._v("Total Items Received")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 col-sm-6 col-md-6 col-lg-6"
  }, [_c('div', {
    staticClass: "text-value txtc"
  }, [_vm._v(_vm._s(_vm.grcData.today.itemsvalue))]), _vm._v(" "), _c('div', {
    staticClass: "text_head txtc"
  }, [_vm._v("Value of Items Received")])])])]), _vm._v(" "), _c('div', {
    staticClass: " col-md-3 main_container",
    staticStyle: {
      "background-color": "#feba25"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 box_header"
  }, [_c('h6', {
    staticClass: "box_head txtc"
  }, [_vm._v("Put Away")])])]), _vm._v(" "), _c('div', {
    staticClass: "row sub_cont"
  }, [_c('div', {
    staticClass: "col-xs-6 col-sm-6 col-md-6 col-lg-6 divider"
  }, [_c('div', {
    staticClass: "text-value txtc"
  }, [_vm._v(_vm._s(_vm.putAwayData.today.itemputaway))]), _vm._v(" "), _c('div', {
    staticClass: "text_head txtc"
  }, [_vm._v("Total Items Putaway")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 col-sm-6 col-md-6 col-lg-6"
  }, [_c('div', {
    staticClass: "text-value txtc"
  }, [_vm._v(_vm._s(_vm.putAwayData.today.itempending))]), _vm._v(" "), _c('div', {
    staticClass: "text_head txtc"
  }, [_vm._v("Items Pending Putaway")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "order"
  }, [_c('div', {
    staticClass: " col-md-4 main_container",
    staticStyle: {
      "background-color": "#7fd2ea",
      "margin-right": "35px"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 box_header"
  }, [_c('h6', {
    staticClass: "box_head txtc"
  }, [_vm._v("Orders")])])]), _vm._v(" "), _c('div', {
    staticClass: "row sub_cont"
  }, [_c('div', {
    staticClass: "col-xs-6 col-sm-6 col-md-3 col-lg-3 divider"
  }, [_c('div', {
    staticClass: "text-value txtc"
  }, [_vm._v(_vm._s(_vm.orderOutboundData.today.orderreceived))]), _vm._v(" "), _c('div', {
    staticClass: "text_head txtc"
  }, [_vm._v("Orders Received")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 col-sm-6 col-md-3 col-lg-3 divider"
  }, [_c('div', {
    staticClass: "text-value txtc"
  }, [_vm._v(_vm._s(_vm.orderOutboundData.today.totalqty))]), _vm._v(" "), _c('div', {
    staticClass: "text_head txtc"
  }, [_vm._v("Order Items Received")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 col-sm-6 col-md-3 col-lg-3 divider"
  }, [_c('div', {
    staticClass: "text-value txtc"
  }, [_vm._v(_vm._s(_vm.orderOutboundData.today.orderfulfilled))]), _vm._v(" "), _c('div', {
    staticClass: "text_head txtc"
  }, [_vm._v("Orders fulfilled")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 col-sm-6 col-md-3 col-lg-3"
  }, [_c('div', {
    staticClass: "text-value txtc"
  }, [_vm._v(_vm._s(_vm.orderOutboundData.today.itemfulfilled))]), _vm._v(" "), _c('div', {
    staticClass: "text_head txtc"
  }, [_vm._v("Items fulfilled")])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: " col-md-11 main_container2",
    staticStyle: {
      "background-color": "#70868b"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 box_header"
  }, [_c('h6', {
    staticClass: "box_head txtc"
  }, [_vm._v("Orders Processed")])])]), _vm._v(" "), _c('div', {
    staticClass: "row sub_cont"
  }, [_c('div', {
    staticClass: "col-xs-2 col-sm-2 col-md-2 col-lg-2 divider"
  }, [_c('div', {
    staticClass: "text_value txtc"
  }, [_vm._v(_vm._s(_vm.pickingData.today.totalorder))]), _vm._v(" "), _c('div', {
    staticClass: "text_head txtc"
  }, [_vm._v("Total orders picked")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-2 col-sm-2 col-md-2 col-lg-2 divider"
  }, [_c('div', {
    staticClass: "text-value txtc"
  }, [_vm._v(_vm._s(_vm.pickingData.today.totalpicked))]), _vm._v(" "), _c('div', {
    staticClass: "text_head txtc"
  }, [_vm._v("Total items picked")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-2 col-sm-2 col-md-2 col-lg-2 divider"
  }, [_c('div', {
    staticClass: "text-value txtc"
  }, [_vm._v(_vm._s(_vm.packingData.today.totalorder))]), _vm._v(" "), _c('div', {
    staticClass: "text_head txtc"
  }, [_vm._v("Total orders packed")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-2 col-sm-2 col-md-2 col-lg-2 divider"
  }, [_c('div', {
    staticClass: "text-value txtc"
  }, [_vm._v(_vm._s(_vm.packingData.today.totalpacked))]), _vm._v(" "), _c('div', {
    staticClass: "text_head txtc"
  }, [_vm._v("Total items packed")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-2 col-sm-2 col-md-2 col-lg-2 divider"
  }, [_c('div', {
    staticClass: "text-value txtc"
  }, [_vm._v(_vm._s(_vm.shippingData.today.totalorder))]), _vm._v(" "), _c('div', {
    staticClass: "text_head txtc"
  }, [_vm._v("Total orders shipped")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-2 col-sm-2 col-md-2 col-lg-2 "
  }, [_c('div', {
    staticClass: "text-value txtc"
  }, [_vm._v(_vm._s(_vm.shippingData.today.totalshipped))]), _vm._v(" "), _c('div', {
    staticClass: "text_head txtc"
  }, [_vm._v("Total items shipped")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12"
  }, [_c('div', {
    staticClass: " col-md-3 main_container",
    staticStyle: {
      "background-color": "#af0606"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 box_header"
  }, [_c('h6', {
    staticClass: "box_head txtc"
  }, [_vm._v("RTO")])])]), _vm._v(" "), _c('div', {
    staticClass: "row sub_cont"
  }, [_c('div', {
    staticClass: "col-xs-6 col-sm-6 col-md-6 col-lg-6 divider"
  }, [_c('div', {
    staticClass: "text-value txtc"
  }, [_vm._v(_vm._s(_vm.RtoData.today.rtomark))]), _vm._v(" "), _c('div', {
    staticClass: "text_head txtc"
  }, [_vm._v("RTO Mark Count")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 col-sm-6 col-md-6 col-lg-6"
  }, [_c('div', {
    staticClass: "text-value txtc"
  }, [_vm._v(_vm._s(_vm.RtoData.today.rtoputaway))]), _vm._v(" "), _c('div', {
    staticClass: "text_head txtc"
  }, [_vm._v("RTO Putaway Count")])])])]), _vm._v(" "), _c('div', {
    staticClass: " col-md-3 main_container",
    staticStyle: {
      "background-color": "#d6ac40"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 box_header"
  }, [_c('h6', {
    staticClass: "box_head txtc"
  }, [_vm._v("SR")])])]), _vm._v(" "), _c('div', {
    staticClass: "row sub_cont"
  }, [_c('div', {
    staticClass: "col-xs-6 col-sm-6 col-md-6 col-lg-6 divider"
  }, [_c('div', {
    staticClass: "text-value txtc"
  }, [_vm._v(_vm._s(_vm.SRData.today.srmark))]), _vm._v(" "), _c('div', {
    staticClass: "text_head txtc"
  }, [_vm._v("SR Mark Count")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 col-sm-6 col-md-6 col-lg-6"
  }, [_c('div', {
    staticClass: "text-value txtc"
  }, [_vm._v(_vm._s(_vm.SRData.today.srputaway))]), _vm._v(" "), _c('div', {
    staticClass: "text_head txtc"
  }, [_vm._v("SR Putaway Count")])])])])])]), _vm._v(" "), _c('b-card', {
    attrs: {
      "title": "Pie Chart"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-4 col-lg-4",
    attrs: {
      "id": "pie-chart-container1"
    }
  }, [(_vm.drTodaychartData.display) ? _c('pie-chart', {
    attrs: {
      "data": _vm.drTodaychartData
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.drTodaychartData.display) ? _c('div', {
    staticClass: "piechartmsg"
  }, [_vm._v("No DR Data Exist")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-4 col-lg-4",
    attrs: {
      "id": "pie-chart-container4"
    }
  }, [(_vm.grcTodaychartData.display) ? _c('pie-chart', {
    attrs: {
      "data": _vm.grcTodaychartData
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.grcTodaychartData.display) ? _c('div', {
    staticClass: "piechartmsg"
  }, [_vm._v("No GRC Data Exist")]) : _vm._e()], 1)])])], 1), _vm._v(" "), _c('b-tab', {
    attrs: {
      "title": "Current Month History"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3 col-lg-3"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-body p-3 d-flex align-items-center"
  }, [_c('i', {
    staticClass: "fa fa-shopping-bag highlight-icon bg-primary p-3 font-2xl mr-3"
  }), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "card-text text-dark "
  }, [_vm._v("Good's Items received per hour")]), _vm._v(" "), _c('strong', [_vm._v(" " + _vm._s(_vm.calculateTodatMonthHrs(_vm.grcData.month.received, 'month')))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-lg-3"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-body p-3 d-flex align-items-center"
  }, [_c('i', {
    staticClass: "fa fa-arrow-down highlight-icon bg-success p-3 font-2xl mr-3"
  }), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "card-text text-dark "
  }, [_vm._v("Items putaway per hour")]), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.calculateTodatMonthHrs(_vm.putAwayData.month.itemputaway, 'month')))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 col-sm-6 col-md-3 col-lg-3"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-body p-3 d-flex align-items-center"
  }, [_c('i', {
    staticClass: "fa fa-arrow-right highlight-icon bg-warning p-3 font-2xl mr-3"
  }), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "card-text text-dark "
  }, [_vm._v("Items picked per hour\n                  ")]), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.calculateTodatMonthHrs(_vm.pickingData.month.totalpicked, 'month')))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 col-sm-6 col-md-3 col-lg-3"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-body p-3 d-flex align-items-center"
  }, [_c('i', {
    staticClass: "fa fa-cube highlight-icon bg-danger p-3 font-2xl mr-3"
  }), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "card-text text-dark "
  }, [_vm._v("Items packed per hour\n                  ")]), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.calculateTodatMonthHrs(_vm.packingData.month.totalpacked, 'month')))])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6 col-lg-3"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-body p-3 d-flex align-items-center"
  }, [_c('i', {
    staticClass: "fa fa-angle-double-up highlight-icon bg-success p-3 font-2xl mr-3"
  }), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "card-text text-dark "
  }, [_vm._v("Items shipped per hour")]), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.calculateTodatMonthHrs(_vm.shippingData.month.totalshipped, 'month')))])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12"
  }, [_c('div', {
    staticClass: " col-md-3 main_container",
    staticStyle: {
      "background-color": "#f38439"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 box_header"
  }, [_c('h6', {
    staticClass: "box_head txtc"
  }, [_vm._v("Dock Receipt")])])]), _vm._v(" "), _c('div', {
    staticClass: "row sub_cont"
  }, [_c('div', {
    staticClass: "col-xs-6 col-sm-6 col-md-6 col-lg-6 divider"
  }, [_c('div', {
    staticClass: "text-value txtc"
  }, [_vm._v(_vm._s(_vm.dockReceiptData.month.totaldr))]), _vm._v(" "), _c('div', {
    staticClass: "text_head txtc"
  }, [_vm._v("Total Dock Receipt")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 col-sm-6 col-md-6 col-lg-6"
  }, [_c('div', {
    staticClass: "text-value txtc"
  }, [_vm._v(_vm._s(_vm.dockReceiptData.month.itemsvalue))]), _vm._v(" "), _c('div', {
    staticClass: "text_head txtc"
  }, [_vm._v("Value of Dock Receipt")])])])]), _vm._v(" "), _c('div', {
    staticClass: " col-md-3 main_container",
    staticStyle: {
      "background-color": "#f76d6c"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 box_header"
  }, [_c('h6', {
    staticClass: "box_head txtc"
  }, [_vm._v("GRC")])])]), _vm._v(" "), _c('div', {
    staticClass: "row sub_cont"
  }, [_c('div', {
    staticClass: "col-xs-6 col-sm-6 col-md-6 col-lg-6 divider"
  }, [_c('div', {
    staticClass: "text-value txtc"
  }, [_vm._v(_vm._s(_vm.grcData.month.received))]), _vm._v(" "), _c('div', {
    staticClass: "text_head txtc"
  }, [_vm._v("Total Items Received")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 col-sm-6 col-md-6 col-lg-6"
  }, [_c('div', {
    staticClass: "text-value txtc"
  }, [_vm._v(_vm._s(_vm.grcData.month.itemsvalue))]), _vm._v(" "), _c('div', {
    staticClass: "text_head txtc"
  }, [_vm._v("Value of Items Received")])])])]), _vm._v(" "), _c('div', {
    staticClass: " col-md-3 main_container",
    staticStyle: {
      "background-color": "#feba25"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 box_header"
  }, [_c('h6', {
    staticClass: "box_head txtc"
  }, [_vm._v("Put Away")])])]), _vm._v(" "), _c('div', {
    staticClass: "row sub_cont"
  }, [_c('div', {
    staticClass: "col-xs-6 col-sm-6 col-md-6 col-lg-6 divider"
  }, [_c('div', {
    staticClass: "text-value txtc"
  }, [_vm._v(_vm._s(_vm.putAwayData.month.itemputaway))]), _vm._v(" "), _c('div', {
    staticClass: "text_head txtc"
  }, [_vm._v("Total Items Putaway")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 col-sm-6 col-md-6 col-lg-6"
  }, [_c('div', {
    staticClass: "text-value txtc"
  }, [_vm._v(_vm._s(_vm.putAwayData.month.itempending))]), _vm._v(" "), _c('div', {
    staticClass: "text_head txtc"
  }, [_vm._v("Items Pending Putaway")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "order"
  }, [_c('div', {
    staticClass: " col-md-4 main_container",
    staticStyle: {
      "background-color": "#7fd2ea",
      "margin-right": "35px"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 box_header"
  }, [_c('h6', {
    staticClass: "box_head txtc"
  }, [_vm._v("Orders")])])]), _vm._v(" "), _c('div', {
    staticClass: "row sub_cont"
  }, [_c('div', {
    staticClass: "col-xs-6 col-sm-6 col-md-3 col-lg-3 divider"
  }, [_c('div', {
    staticClass: "text-value txtc"
  }, [_vm._v(_vm._s(_vm.orderOutboundData.month.orderreceived))]), _vm._v(" "), _c('div', {
    staticClass: "text_head txtc"
  }, [_vm._v("Orders Received")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 col-sm-6 col-md-3 col-lg-3 divider"
  }, [_c('div', {
    staticClass: "text-value txtc"
  }, [_vm._v(_vm._s(_vm.orderOutboundData.month.totalqty))]), _vm._v(" "), _c('div', {
    staticClass: "text_head txtc"
  }, [_vm._v("Order Items Received")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 col-sm-6 col-md-3 col-lg-3 divider"
  }, [_c('div', {
    staticClass: "text-value txtc"
  }, [_vm._v(_vm._s(_vm.orderOutboundData.month.orderfulfilled))]), _vm._v(" "), _c('div', {
    staticClass: "text_head txtc"
  }, [_vm._v("Orders fulfilled")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 col-sm-6 col-md-3 col-lg-3"
  }, [_c('div', {
    staticClass: "text-value txtc"
  }, [_vm._v(_vm._s(_vm.orderOutboundData.month.itemfulfilled))]), _vm._v(" "), _c('div', {
    staticClass: "text_head txtc"
  }, [_vm._v("Items fulfilled")])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: " col-md-11 main_container2",
    staticStyle: {
      "background-color": "#70868b"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 box_header"
  }, [_c('h6', {
    staticClass: "box_head txtc"
  }, [_vm._v("Orders Processed")])])]), _vm._v(" "), _c('div', {
    staticClass: "row sub_cont"
  }, [_c('div', {
    staticClass: "col-xs-2 col-sm-2 col-md-2 col-lg-2 divider"
  }, [_c('div', {
    staticClass: "text_value txtc"
  }, [_vm._v(_vm._s(_vm.pickingData.month.totalorder))]), _vm._v(" "), _c('div', {
    staticClass: "text_head txtc"
  }, [_vm._v("Total orders picked")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-2 col-sm-2 col-md-2 col-lg-2 divider"
  }, [_c('div', {
    staticClass: "text-value txtc"
  }, [_vm._v(_vm._s(_vm.pickingData.month.totalpicked))]), _vm._v(" "), _c('div', {
    staticClass: "text_head txtc"
  }, [_vm._v("Total items picked")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-2 col-sm-2 col-md-2 col-lg-2 divider"
  }, [_c('div', {
    staticClass: "text-value txtc"
  }, [_vm._v(_vm._s(_vm.packingData.month.totalorder))]), _vm._v(" "), _c('div', {
    staticClass: "text_head txtc"
  }, [_vm._v("Total orders packed")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-2 col-sm-2 col-md-2 col-lg-2 divider"
  }, [_c('div', {
    staticClass: "text-value txtc"
  }, [_vm._v(_vm._s(_vm.packingData.month.totalpacked))]), _vm._v(" "), _c('div', {
    staticClass: "text_head txtc"
  }, [_vm._v("Total items packed")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-2 col-sm-2 col-md-2 col-lg-2 divider"
  }, [_c('div', {
    staticClass: "text-value txtc"
  }, [_vm._v(_vm._s(_vm.shippingData.month.totalorder))]), _vm._v(" "), _c('div', {
    staticClass: "text_head txtc"
  }, [_vm._v("Total orders shipped")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-2 col-sm-2 col-md-2 col-lg-2 "
  }, [_c('div', {
    staticClass: "text-value txtc"
  }, [_vm._v(_vm._s(_vm.shippingData.month.totalshipped))]), _vm._v(" "), _c('div', {
    staticClass: "text_head txtc"
  }, [_vm._v("Total items shipped")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12"
  }, [_c('div', {
    staticClass: " col-md-3 main_container",
    staticStyle: {
      "background-color": "#af0606"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 box_header"
  }, [_c('h6', {
    staticClass: "box_head txtc"
  }, [_vm._v("RTO")])])]), _vm._v(" "), _c('div', {
    staticClass: "row sub_cont"
  }, [_c('div', {
    staticClass: "col-xs-6 col-sm-6 col-md-6 col-lg-6 divider"
  }, [_c('div', {
    staticClass: "text-value txtc"
  }, [_vm._v(_vm._s(_vm.RtoData.month.rtomark))]), _vm._v(" "), _c('div', {
    staticClass: "text_head txtc"
  }, [_vm._v("RTO Mark Count")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 col-sm-6 col-md-6 col-lg-6"
  }, [_c('div', {
    staticClass: "text-value txtc"
  }, [_vm._v(_vm._s(_vm.RtoData.month.rtoputaway))]), _vm._v(" "), _c('div', {
    staticClass: "text_head txtc"
  }, [_vm._v("RTO Putaway Count")])])])]), _vm._v(" "), _c('div', {
    staticClass: " col-md-3 main_container",
    staticStyle: {
      "background-color": "#d6ac40"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 box_header"
  }, [_c('h6', {
    staticClass: "box_head txtc"
  }, [_vm._v("SR")])])]), _vm._v(" "), _c('div', {
    staticClass: "row sub_cont"
  }, [_c('div', {
    staticClass: "col-xs-6 col-sm-6 col-md-6 col-lg-6 divider"
  }, [_c('div', {
    staticClass: "text-value txtc"
  }, [_vm._v(_vm._s(_vm.SRData.month.srmark))]), _vm._v(" "), _c('div', {
    staticClass: "text_head txtc"
  }, [_vm._v("SR Mark Count")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 col-sm-6 col-md-6 col-lg-6"
  }, [_c('div', {
    staticClass: "text-value txtc"
  }, [_vm._v(_vm._s(_vm.SRData.month.srputaway))]), _vm._v(" "), _c('div', {
    staticClass: "text_head txtc"
  }, [_vm._v("SR Putaway Count")])])])])])]), _vm._v(" "), _c('b-card', {
    attrs: {
      "title": "Pie Chart"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-4 col-lg-4",
    attrs: {
      "id": "pie-chart-container2"
    }
  }, [(_vm.drMonthchartData.display) ? _c('pie-chart', {
    attrs: {
      "data": _vm.drMonthchartData
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.drMonthchartData.display) ? _c('div', {
    staticClass: "piechartmsg"
  }, [_vm._v("No DR Data Exist")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-4 col-lg-4",
    attrs: {
      "id": "pie-chart-container4"
    }
  }, [(_vm.grcMonthchartData.display) ? _c('pie-chart', {
    attrs: {
      "data": _vm.grcMonthchartData
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.grcMonthchartData.display) ? _c('div', {
    staticClass: "piechartmsg"
  }, [_vm._v("No GRC Data Exist")]) : _vm._e()], 1)])])], 1)], 1) : _vm._e()], 1)])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-4d96aa2a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4d96aa2a","hasScoped":true}!./src/views/components/dashboard/dashboard.component.html
// module id = 1044
// module chunks = 0